import { render, staticRenderFns } from "./QuaySelect.vue?vue&type=template&id=67c0b920&"
import script from "./QuaySelect.vue?vue&type=script&setup=true&lang=ts&"
export * from "./QuaySelect.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports